import { useTranslation } from "react-i18next";
import type { NetworkQuestionnaireProgress } from "src/api/client-api/network/useNetworkLists";
import { formatNumber } from "src/utils/formatting";

type AnswersRow = Pick<NetworkQuestionnaireProgress, "answers" | "questions" | "completionRate">;

export const useNetworkAnswersLabels = () => {
    const { t, i18n } = useTranslation();

    const answersLabel = (row: AnswersRow) =>
        row.questions === null || row.questions === undefined ?
            t("network.panel.answers_without_total", "{{answers}} answers", { answers: row.answers })
        :   t("network.panel.answers", "{{answers}} of {{questions}} answers", {
                answers: row.answers,
                questions: row.questions,
            });

    const answersAndCompletionLabel = (row: AnswersRow) =>
        `${answersLabel(row)} · ${formatNumber(row.completionRate / 100, i18n.resolvedLanguage, {
            style: "percent",
            maximumFractionDigits: 0,
            withPrecisionFloor: false,
        })}`;

    return { answersLabel, answersAndCompletionLabel };
};
